// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iiRFF","selected":"styles_selected__1HmfV"};